import R from 'app/assets/R'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import { useModalHook } from './hook'
import { IPropsDeleteAccount } from './type'
import { BaseCol } from 'app/components/common/BaseCol'
import * as S from './styles'

export const DeleteAccount = (props: IPropsDeleteAccount) => {
  const { visible, isLoading, showModal, handleCancel, handleSubmit, t } =
    useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="delete"
      titleKeyI18n={R.strings.delete_account}
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.delete_account}
      confirmKeyI18n={R.strings.delete_account}
      handleSubmit={handleSubmit}
      visible={visible}
      widthModal={500}
      descriptionDelete={
        <>
          <BaseCol>
            <span>
              {t(R.strings.are_you_want_delete_account)}{' '}
              <S.TextAccount>{props?.name ?? ''}</S.TextAccount>
            </span>
          </BaseCol>
          <BaseCol>
            {t(R.strings.once_the_account_is_locked_it_cannot_be_recovered)}
          </BaseCol>
        </>
      }
    />
  )
}
